/* eslint-disable*/
import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import clsx from 'clsx';
import {
  Grid,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from '@material-ui/core';
import MaterialTable from 'material-table';
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import useDashboard from '../../../../hooks/useDashboard';
import useQuickBook from '../../../../hooks/useQuickBook';
import InfoPopover from '../../../../components/InfoPopover/InfoPopover';
import InfoPopoverComments from '../../../../components/InfoPopoverComments/InfoPopoverComments';
/* Modal */
import useMediaQuery from '@material-ui/core/useMediaQuery';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { useTheme } from '@material-ui/core/styles';
import useStyles from '../../Main.style';
import SummaryInvoiceByCell from '.././SummaryInvoiceByCell/SummaryInvoiceByCell';

//const  = () => {
const MyPersonalPerformance = React.memo(function MyPersonalPerformance(props) {
  /* Modal */
  const key = 'iFrasCwdJh';
  const userCookie = Cookies.get('user');
  const bytes = CryptoJS.AES.decrypt(userCookie, key);
  const loggedInUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  const enableReinitializeValue = true;

  const [cellHistoricTableData, setCellHistoricTableData] = useState([]);

  const { getTotalPastDueInvoicesForAllCells, getProfitRevenue } = useQuickBook();
  const {
    getFileManagementMyCellTable,
    getMyCellInvoicingPerformance,
    getMyInvoicingPerformance,
    getMyLogiwareDetails,
  } = useDashboard();
  const theme = useTheme();
  const [summaryInvoiceByCellArr, setSummaryInvoiceByCellArr] = React.useState([]);
  const [myInvoicingPerformanceData, setMyInvoicingPerformanceData] = useState([]);
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [profitRevenueQbObj, setProfitRevenueQbObj] = React.useState([]);
  const [fileManagementByCellList, setFileManagementByCellList] = useState([]);
  const [myCellInvoicingPerformanceData, setMyCellInvoicingPerformanceData] = useState([]);
  const [profitRevenueQbObjByCell, setProfitRevenueQbObjByCell] = React.useState([]);
  const [myLogiwareData, setMyLogiwareData] = useState([]);
  const [dashboardComments, setDashboardComments] = useState([]);
  const [shouldShowComponent, setShouldShowComponent] = useState(true);
  const loadPastDueInvoicesByCell = async () => {
    const pastDueInvoicesArr = await getTotalPastDueInvoicesForAllCells();
    // fillPastDueTotals(pastDueInvoicesArr?.reportResult);
    setSummaryInvoiceByCellArr(pastDueInvoicesArr?.reportResult || []);
  };
  async function findParentObjectBySearchText(obj, searchText, parentObj = null) {
    if (typeof obj === 'object') {
      if (Array.isArray(obj)) {
        for (var i = 0; i < obj.length; i++) {
          var result = await findParentObjectBySearchText(obj[i], searchText, obj);
          if (result) {
            return result;
          }
        }
      } else {
        for (var prop in obj) {
          if (obj.hasOwnProperty(prop)) {
            var result = await findParentObjectBySearchText(obj[prop], searchText, obj);
            if (result) {
              return result;
            }
            if (
              typeof obj[prop] === 'string' &&
              obj[prop].toLowerCase().indexOf(searchText.toLowerCase()) !== -1
            ) {
              return { object: obj, parent: parentObj };
            }
          }
        }
      }
    }
    return null;
  }
  const loadMyInvoicingPerformance = async () => {
    const myInvoicingPerformance = await getMyInvoicingPerformance({
      userName: loggedInUserData?.userName,
      userId: loggedInUserData?.id,
      countryTitle: loggedInUserData?.country?.countryValue,
    });
    setMyInvoicingPerformanceData(myInvoicingPerformance?.usersResult);
  };

  const loadMyLogiwareDetails = async () => {
    const myLogiwareDetails = await getMyLogiwareDetails({
      userName: loggedInUserData?.userName,
      countryTitle: loggedInUserData?.country?.countryValue,
    });
    setMyLogiwareData(myLogiwareDetails?.usersResult);
  };
  const loadProfitQb = async () => {
    let revenueValue = 0;
    let revenuePrevYearValue = 0;
    let profitValue = 0;
    let profitPrevYearValue = 0;

    let revenueValueByCell = 0;
    let revenuePrevYearValueByCell = 0;
    let profitValueByCell = 0;
    let profitPrevYearValueByCell = 0;

    const resultData = await getProfitRevenue();
    if (resultData) {
      revenueValue = await findParentObjectBySearchText(
        resultData?.reportResultYtd,
        'Total Income',
      );
      revenuePrevYearValue = await findParentObjectBySearchText(
        resultData?.reportResultPrevYear,
        'Total Income',
      );
      profitValue = await findParentObjectBySearchText(resultData?.reportResultYtd, 'Net Income');

      profitPrevYearValue = await findParentObjectBySearchText(
        resultData?.reportResultPrevYear,
        'Net Income',
      );
      setProfitRevenueQbObj({
        revenueValue: revenueValue?.parent[1]?.value,
        revenuePrevYearValue: revenuePrevYearValue?.parent[1]?.value,
        profitValue: profitValue?.parent[1]?.value,
        profitPrevYearValue: profitPrevYearValue?.parent[1]?.value,
      });
    }

    const resultDataByCell = await getProfitRevenue(
      loggedInUserData?.cell?.qbId ||
        (loggedInUserData?.cell?.qbId != '' && { cellId: loggedInUserData?.cell?.qbId }),
    );

    if (resultDataByCell) {
      revenueValueByCell = await findParentObjectBySearchText(
        resultDataByCell?.reportResultYtd,
        'Total Income',
      );
      revenuePrevYearValueByCell = await findParentObjectBySearchText(
        resultDataByCell?.reportResultPrevYear,
        'Total Income',
      );
      profitValueByCell = await findParentObjectBySearchText(
        resultDataByCell?.reportResultYtd,
        'Net Income',
      );

      profitPrevYearValueByCell = await findParentObjectBySearchText(
        resultDataByCell?.reportResultPrevYear,
        'Net Income',
      );

      setProfitRevenueQbObjByCell({
        revenueValueByCell: revenueValueByCell?.parent[1]?.value,
        revenuePrevYearValueByCell: revenuePrevYearValueByCell?.parent[1]?.value,
        profitValueByCell: profitValueByCell?.parent[1]?.value,
        profitPrevYearValueByCell: profitPrevYearValueByCell?.parent[1]?.value,
      });
    }
  };
  const loadManagementMyCellList = async () => {
    const managementMyCellList = await getFileManagementMyCellTable({
      cellValue: loggedInUserData?.cell?.cellValue,
      countryTitle: loggedInUserData?.country?.countryValue,
    });
    setFileManagementByCellList(managementMyCellList?.usersResult);
  };

  const loadMyCellInvoicingPerformance = async () => {
    const myCellInvoicingPerformance = await getMyCellInvoicingPerformance({
      cellValue: loggedInUserData?.cell?.cellValue,
      countryTitle: loggedInUserData?.country?.countryValue,
      cellId: loggedInUserData?.cellId,
    });
    setMyCellInvoicingPerformanceData(myCellInvoicingPerformance?.usersResult || []);
  };

  useEffect(() => {
    const condition = true;
    setShouldShowComponent(condition);
  }, []);
  useEffect(() => {
    loadManagementMyCellList();
  }, []);

  useEffect(() => {
    loadMyLogiwareDetails();
  }, []);

  useEffect(() => {
    loadPastDueInvoicesByCell();
  }, []);

  useEffect(() => {
    loadMyCellInvoicingPerformance();
  }, []);

  useEffect(() => {
    loadMyInvoicingPerformance();
  }, []);

  useEffect(() => {
    loadProfitQb();
  }, []);

  const isMobile = useMediaQuery(theme.breakpoints.down('xs'), {
    defaultMatches: true,
  });

  const classes = useStyles();
  return (
    <>
      <Grid container spacing={4}>
        <Grid item xs={12} className={classes.innercontent}>
          <Grid container style={{ height: '100%' }}>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="h5">
                    My Personal Performance:{' '}
                    {loggedInUserData?.firstName + ' ' + loggedInUserData?.lastName}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <Box className={classes.innercontentWhite} height="100%">
                    <Box display="flex" justifyContent="space-between">
                      <Typography variant="h5" noWrap>
                        INVOICING
                      </Typography>
                      <InfoPopover />
                    </Box>
                    <Box mt={1} className={classes.TableUIV2}>
                      <MaterialTable
                        style={{ boxShadow: 'none' }}
                        options={{
                          toolbar: false,
                          draggable: false,
                          paging: false,
                          sorting: true,
                          pageSize: 20,
                          pageSizeOptions: [10, 20, 50, 100],
                          showTextRowsSelected: false,
                          toolbarButtonAlignment: 'right',
                          showFirstLastPageButtons: false,
                          actionsColumnIndex: -100,
                          emptyRowsWhenPaging: false,
                        }}
                        localization={{
                          pagination: {
                            labelRowsSelect: 'Rows',
                            labelRowsPerPage: 'Rows Per Page',
                          },
                        }}
                        title="File Management"
                        columns={[
                          {
                            title: loggedInUserData?.firstName + ' ' + loggedInUserData?.lastName,
                            field: 'metrix',
                            customSort: (a, b) => a?.metrix.localeCompare(b?.metrix),
                            render: (data) => data?.metrix,
                            //render: (data) => <InfoPopoverComments data={data?.metrix} />,
                          },
                          {
                            title: new Date().getFullYear() + ' YTD',
                            field: 'ytd',
                            customSort: (a, b) => a.ytd.localeCompare(b.ytd),
                            render: (data) =>
                              data?.ytd.includes('(') ? (
                                <Typography className={classes.TableTextRed}>
                                  {data?.ytd}
                                </Typography>
                              ) : (
                                data?.ytd
                              ),
                          },
                          {
                            title: 'Ranking',
                            field: 'vectorranking',
                            customSort: (a, b) => a.vectorRank.localeCompare(b.vectorRank),
                            render: (data) => (
                              <span
                                className={
                                  data?.vectorRank ==
                                  Math.max(...myInvoicingPerformanceData.map((o) => o?.vectorRank))
                                    ? classes.vectorRankingRed
                                    : data?.vectorRank == 1
                                    ? classes.vectorRankingGreen
                                    : classes.vectorranking
                                }
                              >
                                {data?.vectorRank}
                              </span>
                            ),
                          },
                          {
                            title: 'Top Employee',
                            field: 'bestcell',
                            customSort: (a, b) => a.bestCell.localeCompare(b.bestCell),
                            render: (data) =>
                              data?.bestCell.includes('(') ? (
                                <Typography className={classes.TableTextRed}>
                                  {data?.bestCell}
                                </Typography>
                              ) : (
                                data?.bestCell
                              ),
                          },
                          {
                            title: 'Last Year',
                            field: 'previousyear',
                            customSort: (a, b) => a.prevYear.localeCompare(b.prevYear),
                            render: (data) =>
                              data?.prevYear.includes('(') ? (
                                <Typography className={classes.TableTextRed}>
                                  {data?.prevYear}
                                </Typography>
                              ) : (
                                data?.prevYear
                              ),
                          },
                        ]}
                        data={myInvoicingPerformanceData || []}
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <Box className={classes.innercontentWhite} height="100%">
                    <Box display="flex" justifyContent="space-between">
                      <Typography variant="h5" noWrap>
                        FILE MANAGEMENT
                      </Typography>
                    </Box>

                    <Box mt={1} className={classes.TableUIV2}>
                      <MaterialTable
                        style={{ boxShadow: 'none' }}
                        options={{
                          toolbar: false,
                          draggable: false,
                          paging: false,
                          sorting: true,
                          pageSize: 20,
                          pageSizeOptions: [10, 20, 50, 100],
                          showTextRowsSelected: false,
                          toolbarButtonAlignment: 'right',
                          showFirstLastPageButtons: false,
                          actionsColumnIndex: -100,
                          emptyRowsWhenPaging: false,
                        }}
                        localization={{
                          pagination: {
                            labelRowsSelect: 'Rows',
                            labelRowsPerPage: 'Rows Per Page',
                          },
                        }}
                        title="File Management"
                        columns={[
                          {
                            title: loggedInUserData?.firstName + ' ' + loggedInUserData?.lastName,
                            field: 'cellf',
                            render: (data) => data?.metrix,
                          },
                          {
                            title: 'Ranking',
                            field: 'vectorranking',
                            render: (data) => (
                              <span
                                className={
                                  data?.vectorRank ==
                                  Math.max(...myLogiwareData.map((o) => o?.vectorRank))
                                    ? classes.vectorRankingRed
                                    : data?.vectorRank == 1
                                    ? classes.vectorRankingGreen
                                    : classes.vectorranking
                                }
                              >
                                {data?.vectorRank}
                              </span>
                            ),
                          },
                          {
                            title: new Date().getFullYear() + ' Full Year',
                            field: 'ytd',
                            render: (data) =>
                              data?.ytd.includes('(') ? (
                                <Typography className={classes.TableTextRed}>
                                  {data?.ytd}
                                </Typography>
                              ) : (
                                data?.ytd
                              ),
                          },

                          {
                            title: new Date().getFullYear() + ' Top Employee',
                            field: 'bestcell',
                            render: (data) =>
                              data?.bestCell.includes('(') ? (
                                <Typography className={classes.TableTextRed}>
                                  {data?.bestCell}
                                </Typography>
                              ) : (
                                data?.bestCell
                              ),
                          },
                          {
                            title: new Date().getFullYear() - 1 + ' Full Year',
                            field: 'previousyear',
                            render: (data) =>
                              data?.prevYear.includes('(') ? (
                                <Typography className={classes.TableTextRed}>
                                  {data?.prevYear}
                                </Typography>
                              ) : (
                                data?.prevYear
                              ),
                          },
                        ]}
                        data={myLogiwareData || []}
                      />
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="flex-end"
                alignItems="flex-end"
                height={1}
                mt={0.5}
              >
                <Box display="flex" justifyContent="flex-end" alignItems="center">
                  <Box>
                    <Typography variant="body2">View all</Typography>
                  </Box>
                  <Box className={classes.ViewAll}>
                    <ArrowForwardIcon />
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}></Grid>
      </Grid>
      <Grid container spacing={4}>
        <Grid item xs={12} className={classes.innercontent}>
          <Grid container style={{ height: '100%' }}>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="h5">
                    My Cell's Performance: {'Cell ' + loggedInUserData?.cell?.cellTitle}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <Box className={classes.innercontentWhite} height="100%">
                    <Box display="flex" justifyContent="space-between">
                      <Typography variant="h5" noWrap>
                        INVOICING
                      </Typography>
                      <InfoPopover
                        dashboardComments={dashboardComments}
                        dashboardSectionText={"My Cell's Performance"}
                      />
                    </Box>

                    {shouldShowComponent && (
                      <SummaryInvoiceByCell
                        reportArr={summaryInvoiceByCellArr}
                        myCellInvoiceArray={myCellInvoicingPerformanceData}
                        myProfitRevenue={profitRevenueQbObjByCell}
                        dashboardComments={dashboardComments}
                        dashboardSectionText={"My Cell's Performance"}
                      />
                    )}
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <Box className={classes.innercontentWhite} height="100%">
                    <Box display="flex" justifyContent="space-between">
                      <Typography variant="h5" noWrap>
                        FILE MANAGEMENT
                      </Typography>
                    </Box>

                    <Box mt={1} className={classes.TableUIV2}>
                      <MaterialTable
                        style={{ boxShadow: 'none' }}
                        options={{
                          toolbar: false,
                          draggable: false,
                          paging: false,
                          sorting: true,
                          pageSize: 20,
                          pageSizeOptions: [10, 20, 50, 100],
                          showTextRowsSelected: false,
                          toolbarButtonAlignment: 'right',
                          showFirstLastPageButtons: false,
                          actionsColumnIndex: -100,
                          emptyRowsWhenPaging: false,
                        }}
                        localization={{
                          pagination: {
                            labelRowsSelect: 'Rows',
                            labelRowsPerPage: 'Rows Per Page',
                          },
                        }}
                        title="File Management"
                        columns={[
                          {
                            title: 'Cell ' + loggedInUserData?.cell?.cellTitle,
                            field: 'cellf',
                            render: (data) => data?.metrix,
                          },
                          {
                            title: new Date().getFullYear() + ' YTD',
                            field: 'ytd',

                            render: (data) =>
                              typeof data?.ytd === 'string' && data.ytd.includes('(') ? (
                                <Typography className={classes.TableTextRed}>
                                  {data?.ytd}
                                </Typography>
                              ) : (
                                data?.ytd
                              ),
                          },
                          {
                            title: 'Ranking',
                            field: 'vectorranking',
                            render: (data) => (
                              <span
                                className={
                                  data?.vectorRank ==
                                  Math.max(...fileManagementByCellList.map((o) => o?.vectorRank))
                                    ? classes.vectorRankingRed
                                    : data?.vectorRank == 1
                                    ? classes.vectorRankingGreen
                                    : classes.vectorranking
                                }
                              >
                                {data?.vectorRank}
                              </span>
                            ),
                          },
                          {
                            title: 'Top Cell',
                            field: 'bestcell',

                            render: (data) =>
                              typeof data?.bestCell === 'string' && data.bestCell.includes('(') ? (
                                <Typography className={classes.TableTextRed}>
                                  {data?.bestCell}
                                </Typography>
                              ) : (
                                data?.bestCell
                              ),
                          },
                          {
                            title: 'Previous Year',
                            field: 'previousyear',

                            render: (data) =>
                              typeof data?.prevYear === 'string' && data.prevYear.includes('(') ? (
                                <Typography className={classes.TableTextRed}>
                                  {data?.prevYear}
                                </Typography>
                              ) : (
                                data?.prevYear
                              ),
                          },
                        ]}
                        data={fileManagementByCellList || []}
                      />
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="flex-end"
                alignItems="flex-end"
                height={1}
                mt={0.5}
              >
                <Box display="flex" justifyContent="flex-end" alignItems="center">
                  <Box>
                    <Typography variant="body2">View all</Typography>
                  </Box>
                  <Box className={classes.ViewAll}>
                    <ArrowForwardIcon />
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}></Grid>
      </Grid>
    </>
  );
});

export default MyPersonalPerformance;
